/* LA LIBRERÍA — el mostrador de préstamo de las animaciones.
   Cuadros Splash (15 sep 2026).

   EL PROBLEMA QUE RESUELVE
   El tema tiene 18 ficheros de librería en `assets/`, 657 KB en total.
   Si se cargaran todos, cada visitante pagaría medio mega para ver, como
   mucho, dos efectos. Y si cada guion se descargara los suyos por su cuenta,
   dos guiones que necesiten SplitText lo pedirían dos veces.

   Aquí se pide por nombre y se sirve una sola vez:

       csLib.pide('splittext').then(function () { ... });
       csLib.pide(['flip', 'drawsvg']).then(function () { ... });

   La promesa de cada librería se guarda: la segunda petición devuelve la
   misma, no otra descarga. Y las de GSAP se registran solas al llegar
   (`gsap.registerPlugin`), que es el paso que todo el mundo olvida.

   DE DÓNDE SALEN LAS RUTAS
   No se pueden escribir a mano: Shopify sirve los assets desde su CDN con un
   sello de versión en la URL (`?v=1789...`), y ese sello cambia en cada
   subida. Liquid escribe el mapa en un <script type="application/json"> y
   aquí se lee. Si el mapa no está —una plantilla que no lo imprima—, se
   rechaza la promesa y quien pidió la librería se queda con su plan B, que
   es lo que toda coreografía de esta casa tiene que tener.

   QUÉ NO HACE
   No decide CUÁNDO animar. Eso es de cada guion: aquí no se mira ni el
   «reducir movimiento» ni el ancho de la pantalla. Este fichero solo trae
   ficheros; que haya que traerlos o no, lo dice quien los pide.
*/
(function () {
  'use strict';

  var mapa = null;
  try {
    var nodo = document.getElementById('cs-librerias');
    if (nodo) mapa = JSON.parse(nodo.textContent);
  } catch (e) {
    /* JSON roto: se queda en null y todo el mundo se va a su plan B */
  }

  var pendientes = {};

  /* Los de GSAP hay que registrarlos, y el nombre global no siempre coincide
     con el del fichero. Lo que va a la derecha es cómo se llama el plugin en
     `window` una vez cargado. */
  var PLUGINS_GSAP = {
    scrolltrigger: 'ScrollTrigger',
    splittext: 'SplitText',
    flip: 'Flip',
    observer: 'Observer',
    draggable: 'Draggable',
    inertia: 'InertiaPlugin',
    drawsvg: 'DrawSVGPlugin',
    morphsvg: 'MorphSVGPlugin',
    motionpath: 'MotionPathPlugin',
    scrollto: 'ScrollToPlugin',
    scrollsmoother: 'ScrollSmoother',
    text: 'TextPlugin',
    customease: 'CustomEase'
  };

  function bajaFichero(url) {
    return new Promise(function (bien, mal) {
      var s = document.createElement('script');
      s.src = url;
      s.async = false; /* respeta el orden si se piden varias de golpe */
      s.onload = function () { bien(); };
      s.onerror = function () { mal(new Error('no cargó ' + url)); };
      document.head.appendChild(s);
    });
  }

  function una(nombre) {
    nombre = String(nombre).toLowerCase();
    if (pendientes[nombre]) return pendientes[nombre];

    var global = PLUGINS_GSAP[nombre];
    /* ¿Ya está en la página? Puede venir de una etiqueta suelta: gsap lo
       carga la sección del sofá, y ScrollTrigger va con él. */
    if (global && window[global]) {
      pendientes[nombre] = Promise.resolve(window[global]);
      return pendientes[nombre];
    }
    if (nombre === 'gsap' && window.gsap) {
      pendientes[nombre] = Promise.resolve(window.gsap);
      return pendientes[nombre];
    }

    if (!mapa || !mapa[nombre]) {
      return Promise.reject(new Error('sin ruta para ' + nombre));
    }

    var cadena = nombre === 'gsap' ? Promise.resolve() : una('gsap');
    /* Todo lo de GSAP necesita a GSAP delante; lo que no es de GSAP
       (Lenis, curtains, matter, lottie) no depende de nadie. */
    if (!global && nombre !== 'gsap') cadena = Promise.resolve();

    pendientes[nombre] = cadena
      .then(function () { return bajaFichero(mapa[nombre]); })
      .then(function () {
        if (global && window.gsap && window[global]) {
          window.gsap.registerPlugin(window[global]);
          return window[global];
        }
        return true;
      });
    return pendientes[nombre];
  }

  window.csLib = {
    /* Un nombre o una lista. Devuelve promesa siempre. */
    pide: function (que) {
      if (!Array.isArray(que)) return una(que);
      return Promise.all(que.map(una));
    },
    /* Para mirar desde la consola qué se ha llegado a pedir. */
    pedidas: function () { return Object.keys(pendientes); },
    hayMapa: function () { return !!mapa; }
  };
})();
